<template>
    <div class="flex w-full flex-col gap-4 rounded bg-white p-6 shadow">
        <div class="font-semibold">Account Information</div>
        <div class="">
            <form-input
                label="First Name"
                name="first_name"
                v-model="form.first_name"
            />
        </div>
        <div class="">
            <form-input
                label="Last Name"
                name="last_name"
                v-model="form.last_name"
            />
        </div>
        <div class="">
            <form-input label="Email" name="email" v-model="form.email" />
        </div>
        <div class="">
            <label class="mb-2 block text-[14px] font-semibold">Avatar</label>
            <div
                v-if="user.avatar"
                class="group relative h-[160px] w-[160px] rounded border border-gray-400 bg-gray-250 bg-cover bg-center bg-no-repeat"
                :style="'background-image: url(' + user.avatar + ')'"
            >
                <div
                    class="invisible absolute bottom-0 flex w-full group-hover:visible"
                >
                    <span
                        class="flex-grow rounded-b bg-black/75 px-2 py-1 text-center text-[14px] font-medium text-white hover:cursor-pointer hover:bg-white hover:text-black"
                        @click="editAvatar"
                        title="Edit / Remove"
                    >
                        Edit / Remove
                    </span>
                </div>
            </div>
            <drag-image-upload-field
                v-else
                v-model="form.avatar"
                image-preview-css="h-[160px] w-[160px] border border-gray-400 bg-gray-250"
            >
                <div class="text-center">
                    <div class="">Upload an avatar</div>
                    <div class="text-[12px] font-medium">(jpg or png)</div>
                </div>
            </drag-image-upload-field>
        </div>

        <div class="">
            <FormInputDatepicker
                label-classes="mb-2 block font-semibold block text-[14px]"
                css-classes="appearance-none w-full p-2 pr-12"
                label="Test Date"
                name="new_test_date"
                v-model="form.test_date"
            >
            </FormInputDatepicker>
        </div>
        <div class="">
            <form-select
                label="Timezone"
                name="timezone"
                v-model="form.timezone"
                :options="timezoneOptions"
            ></form-select>
        </div>
        <div class="flex justify-end">
            <div
                v-if="form.isDirty"
                @click="save()"
                class="rounded bg-primary-525 px-2 py-3 text-white hover:cursor-pointer hover:bg-primary-625"
            >
                Save Changes
            </div>
            <div
                v-else
                class="rounded bg-primary-525 px-2 py-3 text-white opacity-50 hover:cursor-not-allowed"
            >
                Save Changes
            </div>
        </div>
    </div>
</template>
<script>
import DragImageUploadField from "@/Components/DragImageUploadField.vue";
import FormInput from "@/Components/FormInput.vue";
import FormInputDatepicker from "@/Components/FormInputDatepicker.vue";
import FormSelect from "@/Components/FormSelect.vue";
import dayjs from "dayjs";

export default {
    name: "StudentAccountInformationForm",
    components: {
        DragImageUploadField,
        FormInput,
        FormInputDatepicker,
        FormSelect,
    },
    props: {
        user: {},
    },
    data() {
        return {
            form: this.$inertia.form({
                avatar: this.user.avatar,
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                email: this.user.email,
                test_date: this.user.test_day
                    ? dayjs(this.user.test_day.date)
                          .utc(false)
                          .format(this.$page.props.date_formats.datepicker)
                    : null,
                timezone: this.user.timezone,
            }),
            timezoneOptions: [
                { label: "Eastern", value: "America/New_York" },
                { label: "Central", value: "America/Chicago" },
                { label: "Mountain", value: "America/Denver" },
                { label: "Mountain no DST", value: "America/Phoenix" },
                { label: "Pacific", value: "America/Los_Angeles" },
                { label: "Alaska", value: "America/Anchorage" },
                { label: "Hawaii", value: "America/Adak" },
                { label: "Hawaii no DST", value: "Pacific/Honolulu" },
            ],
        };
    },
    methods: {
        editAvatar() {
            this.user.avatar = null;
            this.form.avatar = null;
        },
        save() {
            let vm = this;

            this.$inertia.post(
                route("student.account.update-profile"),
                {
                    avatar: this.form.avatar,
                    first_name: this.form.first_name,
                    last_name: this.form.last_name,
                    email: this.form.email,
                    test_date: this.form.test_day,
                    timezone: this.form.timezone,
                },
                {
                    onSuccess: function () {
                        vm.form.isDirty = false;
                    },
                }
            );
        },
    },
};
</script>
